import { MapPinIcon } from '@heroicons/react/24/outline';

interface GeolocationEmptyStateProps {
  searchIsActive: boolean;
}

export function GeolocationEmptyState({
  searchIsActive,
}: GeolocationEmptyStateProps) {
  return (
    <div
      className="flex justify-center px-[24px] py-12"
      data-testid="geolocation-empty-state"
    >
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-200">
          <MapPinIcon className="h-7 w-7" />
        </div>
        <h4 className="mt-3 text-gray-700">{emptyStateText(searchIsActive)}</h4>
      </div>
    </div>
  );
}

const emptyStateText = (searchIsActive: boolean) => {
  return searchIsActive
    ? 'No geolocations match your search'
    : 'No geolocations found';
};
